import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面未找到 - 爆料专区导航',
    description: '你访问的页面不存在或已被移动，返回首页继续查看爆料专区首页入口、网址网页与热门讨论区导航。',
    keywords: '爆料专区,页面未找到,爆料专区导航',
    path: location.pathname,
  });

  return (
    <main className="pt-16 md:pt-20">
      <div className="w-full px-4 md:px-8 lg:px-12 py-20 md:py-28 text-center">
        <p className="font-heading text-6xl md:text-8xl font-bold text-primary-200 select-none">404</p>
        <h1 className="font-heading mt-6 text-2xl md:text-4xl font-bold text-foreground-950">
          这个页面走丢了
        </h1>
        <p className="mt-4 text-sm md:text-base text-foreground-600">
          你访问的地址不存在或已被移动：<span className="font-mono text-foreground-800">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-layout-grid-line" />
            浏览热门话题
          </Link>
        </div>
      </div>
    </main>
  );
}